module.exports = __webpack_public_path__ + "img/icon_menu_comentarios.c76268ce.svg";